<template>
    <div class="mb-5">
        <strong class="d-block" v-html="offer.name" />
        <strong class="d-block">
            {{ $t('date') }}: {{ $filters.dateFormat(startDate) }} - {{ $filters.dateFormat(endDate) }}
        </strong>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_INSURANCE_CONDITIONS_INFO} from '@/utils/event-bus'

    @Component
    export class InsuranceConditionsModalInfo extends Vue {
        searchRequest = {}
        offer = {}

        mounted() {
            EventBus.$on(SHOW_INSURANCE_CONDITIONS_INFO, this.showInfo)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_INSURANCE_CONDITIONS_INFO, this.showInfo)
        }

        showInfo({searchRequest, offer}) {
            this.searchRequest = searchRequest
            this.offer = offer
        }

        get startDate() {
            return this.searchRequest.startDate
        }

        get endDate() {
            return this.searchRequest.endDate
        }
    }

    export default InsuranceConditionsModalInfo
</script>
